/* eslint-disable no-param-reassign */

'use-strict';

import { IScope } from 'angular';
import { RootScope } from '../../app.config';
import { InterfaceService } from '../../shared/interface/interface.service';
import { ToastService, ToastType } from '../../ui-components/toast/toast.service';
import { NotificationService } from '../../shared/browser-functions/notification.service';
import OnboardingComponent from '../../src/app/onboarding/onboarding.component';

interface UserSettingsScope extends IScope {
  userSettings: {
    csvExcelCompatability?: boolean,
  },
  globals: unknown,
  pushNotificationsPermitted: boolean,
  supportsNotificationsAPI: boolean,
  supportsPushAPI: boolean,
  notificationsAPIEnabled: boolean,
  pwaIsInstalled: boolean,
  pwaIsInstallable: boolean,
  pushAPIEnabled: boolean,
  interfaceService: InterfaceService,
  changeExcelCompatability: () => void,
}

/* @ngInject */
export default function UserSettingsController(
  $rootScope: RootScope,
  $scope: UserSettingsScope,
  notificationService: NotificationService,
  toastService: ToastService,
  interfaceService: InterfaceService,
): void {
  /**
   * CONSTRUCTOR
   */
  const init = () => {
    $scope.userSettings = {};
    $scope.userSettings.csvExcelCompatability = $rootScope.globals.csvExcelCompatability === true;

    $scope.interfaceService = interfaceService;
    $scope.pushNotificationsPermitted = $rootScope.globals.pushNotificationsPermission === true;
    $scope.supportsNotificationsAPI = notificationService.browserSupportsNotificationsAPI();
    $scope.supportsPushAPI = notificationService.browserSupportsPushAPI();
    $scope.notificationsAPIEnabled = $rootScope.globals.notificationsAPIInitialized === true;
    $scope.pwaIsInstalled = interfaceService.pwaIsInstalled();
    $scope.pwaIsInstallable = interfaceService.pwaIsInstallable();
    $scope.pushAPIEnabled = $rootScope.globals.pushAPIInitialized === true;

    $scope.globals = $rootScope.globals;
  };

  $scope.changeExcelCompatability = () => {
    $rootScope.globals.csvExcelCompatability = $scope.userSettings.csvExcelCompatability;
    toastService.toast(ToastType.SUCCESS, 'Einstellungen gespeichert');
  };

  init();
}
